import { useState } from "react";
import { Button, Nav, NavDropdown, Offcanvas } from "react-bootstrap"
import logo from "../../images/logo/Icon_company.png";

import { BsJustify, BsArchive, BsBarChart, BsCheckSquare, BsHouseGear, BsCalendar2X, BsCalendar3, BsUiChecksGrid } from "react-icons/bs";
import { getUserData } from "./getUserRole";
import { CreateAuditOffcanvass } from "./CreateAuditOffcanvas";


const MainNavbar = () =>{
    const [show, setShow] = useState(false);

    const user_data_role=getUserData();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return(
        <>
            <BsJustify onClick={handleShow} className="icon_button_navbar"/>

            <Offcanvas show={show} onHide={handleClose} style={{ maxWidth:"375px", width:"270px"}}>
                <Offcanvas.Header closeButton>
                </Offcanvas.Header>
                <Offcanvas.Body >
                <div>
                    <div>
                        <img 
                            src={logo}
                            height="auto"
                            width="100%"
                            alt="Logo" 
                        />
                    </div> 
                    <h3 className="menu_text">
                        AIDA
                    </h3>
                    <Nav className="flex-column">
                        {(["Admin"].includes(user_data_role)) ? <Nav.Link 
                            href="/admin_page_settings" 
                            className="icon_label_block">
                                <BsHouseGear />
                                <span className="icon_text">Настройки админа</span>
                        </Nav.Link> : null}
                        <Nav.Link 
                            href="/calendar_page" 
                            className="icon_label_block">
                                <BsCalendar3/>
                                <span className="icon_text">Календарь аудитов</span>
                        </Nav.Link>
                        {/* <Nav.Link 
                            href="/dashboard_page" 
                            className="icon_label_block">
                                <BsUiChecksGrid/>
                                <span className="icon_text">Дашборд аудитов</span>
                        </Nav.Link> */}
                        <Nav.Link 
                            href="/main_page" 
                            className="icon_label_block">
                                <BsCheckSquare/>
                                <span className="icon_text">Аудиты</span>
                        </Nav.Link>
                        {(["Admin","Admin-RO","Moderator"].includes(user_data_role)) ? 
                        <div>
                            <Nav.Link 
                                href="/compare_results_audit" 
                                className="icon_label_block">
                                    <BsBarChart/>
                                    <span className="icon_text">Сравнить аудиты</span>
                            </Nav.Link>
                            <Nav.Link 
                                href="/planing_audit" 
                                className="icon_label_block">
                                    <BsCalendar2X/>
                                    <span className="icon_text">Организовать аудит</span>
                            </Nav.Link>
                            {/* <CreateAuditOffcanvass/> */}
                            <Nav.Link 
                                href="/archive_results_audit" 
                                className="icon_label_block">
                                    <BsArchive />
                                    <span className="icon_text">Архив</span>
                            </Nav.Link>
                        </div>
                        :null}
                    </Nav>
                </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default MainNavbar;